class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
  upsellProducts = '';
  selectedVariantIds = {}
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    fetch(`${routes.cart_url}.js`).then(data => data.json()).then(results => {
      this.initUpsellProducts(results)
    })
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  async initUpsellProducts(data) {
    const productIdsInCart = data.items.filter(item => item.handle !== "navidium-shipping-protection").map(item => item.product_id);

    if(data.items.length > 0){
        const allRecommendedProducts = [];
    
        for (const productId of productIdsInCart) {
            const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=4&intent=related`);
            const newProductData = await response.json();
            allRecommendedProducts.push(...newProductData.products);
        }
    
        // LOGIC TO REMOVE DUPLICATE PRODUCTS
        const uniqueRecommendedProducts = allRecommendedProducts.filter((product, index, self) =>
            index === self.findIndex((p) => p.id === product.id)
        );
    
        // CHECK TO MAKE SURE THE PRODUCT IS NOT ALREADY IN THE CART
        const filteredRecommendedProducts = uniqueRecommendedProducts.filter(product =>
            !productIdsInCart.includes(product.id)
        );
        console.log('filteredRecommendedProducts',filteredRecommendedProducts)
        let recommendation_markup = '';
        const currency__symbol = document.querySelector('.cart__product-rec-list .list__inner').getAttribute('data-cur-symbol');
        for(let i=0; i < filteredRecommendedProducts.slice(-4).length; i++) {
            recommendation_markup += `<div class="list_product d-flex align-items-center py-4">
            <div class="image_block"><a class="d-inline-block" href="/products/${filteredRecommendedProducts[i].handle}"><img width="100%" height="100%" class="object-fit-cover" src="${filteredRecommendedProducts[i].images[0]}"/>
            </a></div><div class="px-4 line__item-info"><h4 class="product__title">${filteredRecommendedProducts[i].title}</h4><p class="price mb-4 d-inline-block">${currency__symbol}${(filteredRecommendedProducts[i].price/100)}</p>
            <p class="text-decoration-line-through compare_price pl-4 ${(filteredRecommendedProducts[i].compare_at_price == null) ? "d-none":"d-inline-block"}">${currency__symbol}${filteredRecommendedProducts[i].compare_at_price/100}</p>
            </div>
            <div class="cta_block"><button type="button" class="button button-primary btn1" ${(!filteredRecommendedProducts[i].variants[0].available) ? "disabled":''} data-add-btn data-variant="${filteredRecommendedProducts[i].variants[0].id}">${(filteredRecommendedProducts[i].variants[0].available) ? "Add":'Sold Out'}</button>
            </div></div>`
        }

        document.querySelector('.cart__product-rec-list .list__inner').innerHTML = recommendation_markup;
        const buttons = document.querySelectorAll('[data-add-btn]');
        buttons.forEach((el)=>{
            el.addEventListener('click',async (ev)=>{
                await this.addItem(data,ev.target.dataset.variant);
            })
        })
        this.upsellProducts = filteredRecommendedProducts;
        this.upsellProducts.forEach(product => {
            if (product.variants.length > 0) {
                const availableVariant = product.variants.find(variant => variant.available);
                if (availableVariant) {
                this.selectedVariantIds[product.id] = availableVariant.id;
                } else {
                    console.error("No available variant for product:", product.id);
                }
            }
        });
    }
  }
  addItem = async (data,id) => {  // make this function async
    let formData = {
        items: [
            {
                id: id,
                quantity: 1,
            },
        ],
    };
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
      });
      const cartData = await response.json();
      console.log('cartData',cartData)    
      publish(PUB_SUB_EVENTS.cartUpdate, e => {
          "cart-items" !== e.source && this.onCartUpdate();
      });  
    } catch (error) {
      console.error("Error:", error);
    } finally {
      $.getJSON('/cart.js', function(cart){ 
          document.querySelector('.cart-count-bubble').innerHTML = cart.item_count;
      });
    }
  };
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
